import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PersonHiringBlocked as PersonHiringBlockedComponent } from '@ibk/beneficios';
export default function PersonHiringBlocked() {
    const navigate = useNavigate();
    return _jsx(PersonHiringBlockedComponent, { onBackToBenefits: () => navigate('/beneficios') });
}
